export default "__VITE_ASSET__flGjLF0Z__"